<template>
        <div class="agency"> <!--, 0 2px 10px 0 rgba(0,0,0,.12);">   -->  
            <!-- Section: Agency -->
            <section id="agency" class="section wow fadeIn" data-wow-delay="0.3s">

                <!-- Section heading 
                <h1 class="section-heading h1 pt-4">Die Agentur</h1>      -->     
                
                <!--Grid row-->
                <div class="row text-center pt-5">

                    <!--Grid column-->
                    <div class="col-md-12 mb-r px-4">

<!--                        <div class="avatar heimann">
                            <img src="./../assets/img/agentur.png" width="180px" class="z-depth-1" alt="Sylvia Heimann">
                        </div>
                        <h4 class="my-3 font-bold">Sylvia Heimann</h4>-->

                        <!--Facebook und Instagram
                        <a class="icons-sm fb-ic"><i class="fa fa-facebook" style="color: #0188c0;"> </i></a>
                        
                        <a class="icons-sm ins-ic"><i class="fa fa-instagram" style="color: #0188c0;"> </i></a>-->

                        <p class="section-description" v-lang.agenturText1></p>

                        <p class="section-description" v-lang.agenturText2></p>    

                        <p class="section-description" v-lang.agenturText3></p>

                        <p class="section-description" v-lang.agenturText4></p>

                        <p class="section-description">Sylvia Heimann</p>

                    </div>
                    <!--Grid column-->

                </div>
                <!--Grid row-->

            </section>
            <!-- /Section: Agency -->
        </div>
  
</template>

<script>
export default {

}
</script>

<style>
    #agency {
        background: white;
        background-image: url('./../assets/img/strahlen.png');
        /*background-image: url('./../assets/img/wall2.jpg');*/
    }

    .agency {
        background-color: rgba(255,255,255,0.5);
        box-shadow: 0 0px 50px 0 rgba(0,0,0,.16);
    }

    .section-description {
        text-align: justify;
        margin-top:20px;
        margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Agency.vue